export default {
  header:
    "fixed left-0 top-0 right-0 p-3 rounded-b-md shadow-md flex justify-between bg-[#222222] text-white",
  form: "flex flex-col justify-center items-center w-full rounded-md mt-40 p-3",
  greenButton:
    "bg-gradient-to-tr from-green-200 to-green-300 rounded-md shadow-md mt-5 px-5 py-3 cursor-pointer text-black",
  buttonRed:
    "bg-gradient-to-tr from-red-200 to-red-300 rounded-md shadow-md mt-5 px-5 py-3 cursor-pointer",
  input: "py-2 px-3 text-center font-bold rounded-md shadow-md my-5",
  movieCard:
    "flex flex-col justify-center items-center p-5 mx-10 my-20 rounded-md shadow-md text-center bg-[#222222] text-white",
  nav: "bg-[#222222] fixed inset-0 flex flex-col justify-center items-center text-center text-white",
};
